import Notice from "@/views/support/Notice.vue";
import Inquiry from "@/views/support/Inquiry.vue";
import NoticeDetail from "@/views/support/NoticeDetail.vue";
import InquiryDetail from "@/views/support/InquiryDetail.vue";
import InquiryCreate from "@/views/support/InquiryCreate.vue";
import FAQ from "@/views/support/FAQ.vue";

export const supportRoutes = [
    {
        path: '/my/support/notice',
        name: 'Notice',
        component: Notice,
        meta: {
            analytics: {
                category: 'support',
                type: 'notice_list'
            }
        }
    },
    {
        path: '/my/support/notice/:uuid',
        name: 'NoticeDetail',
        component: NoticeDetail,
        props: true,
        meta: {
            analytics: {
                category: 'support',
                type: 'notice_detail'
            }
        }
    },
    {
        path: '/my/support/inquiry',
        name: 'Inquiry',
        component: Inquiry,
        meta: {
            analytics: {
                category: 'support',
                type: 'inquiry_list'
            }
        }
    },
    {
        path: '/my/support/inquiry/:uuid',
        name: 'InquiryDetail',
        component: InquiryDetail,
        props: true,
        meta: {
            analytics: {
                category: 'support',
                type: 'inquiry_detail'
            }
        }
    },
    {
        path: '/my/support/inquiry/create',
        name: 'InquiryCreate',
        component: InquiryCreate,
        meta: {
            analytics: {
                category: 'support',
                type: 'inquiry_create'
            }
        }
    },
    {
        path: '/my/support/faq',
        name: 'FAQ',
        component: FAQ,
        meta: {
            analytics: {
                category: 'support',
                type: 'faq'
            }
        }
    },
];
